<template>
  <i-modal
    :value="show"
    :closable="false"
    width="680"
    footer-hide
    :mask-closable="false"
    @on-visible-change="visibleChangeHandler">
    <div class="media-content">
      <div class="close-btn" @click="$emit('close-modal')">
        <i-icon type="ios-close" />
      </div>
      <template v-if="mediaType === 'jpg'">
        <img :src="mediaPath" @contextmenu.prevent />
      </template>
      <template v-else-if="mediaType === 'mp4'">
        <video-player ref="video" :media-path="mediaPath" :video-cover="videoCover" height="40vh" />
      </template>
      <template v-else-if="mediaType === 'mp3'">
        <audio-player ref="audio" :media-path="mediaPath" />
      </template>
    </div>
  </i-modal>
</template>

<script>
import VideoPlayer from './VideoPlayer.vue';
import AudioPlayer from './AudioPlayer.vue';

function mediaTypeValidate(type) {
  const types = ['', 'jpg', 'mp3', 'mp4', 'pdf'];

  return types.includes(type);
}

export default {
  name: 'PreviewMediaModal',
  components: {
    VideoPlayer,
    AudioPlayer,
  },
  props: {
    show: { type: Boolean, required: true },
    mediaPath: { type: String, required: true },
    mediaType: { type: String, required: true, validator: mediaTypeValidate },
    videoCover: { type: String },
  },
  data() {
    return {
      mediaLoaded: false,
    };
  },
  watch: {
    mediaPath() {
      this.mediaLoaded = false;

      if (this.mediaType === 'jpg') {
        this.preloadImage();
      }
    },
  },
  methods: {
    /**
     * 模态框显示状态改变
     */
    visibleChangeHandler(flag) {
      if (!flag) {
        if (this.mediaType === 'mp4') {
          this.$refs.video.$el.querySelector('video').pause();
        } else if (this.mediaType === 'mp3') {
          this.$refs.audio.$el.querySelector('audio').pause();
        }

        this.$emit('close-modal');
      }
    },
    /**
     * 预加载图片
     */
    preloadImage() {
      const image = new Image();

      image.src = this.mediaPath;

      image.onload = () => {
        this.mediaLoaded = true;
      };

      image.onerror = () => {
        alert('图片预览加载失败');
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-modal {
  top: 18vh;

  .ivu-modal-content {
    border-radius: 0;
    background-color: transparent;
    box-shadow: none;
  }
}

.media-content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 12px;
  background-color: #fbf9fb;

  > .close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(50%) translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .52);
    cursor: pointer;

    > i {
      font-size: 32px;
      color: #fff;
    }
  }

  img {
    width: 100%;
  }

.mp3 {
  width: 100%;

  & > audio {
    width: 100%;

    &:focus {
      outline: none;
    }
  }
}
}

.spin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
}
</style>
